import { useCallback } from 'react';

import useInterval from 'hooks/use-interval';
import { useNetworkContext } from 'state/network';
import { useOffersContext } from 'state/offers';

export const OFFERS_REFRESH_INTERVAL = 60000; // 60 (s) * 1000 (ms)

export default function useOffersRefresh() {
  const {
    connection: { connected },
    hasNetworkError,
  } = useNetworkContext();
  const { refreshOffers } = useOffersContext();
  const refreshIfConnected = useCallback(() => {
    if (connected && !hasNetworkError) {
      refreshOffers();
    }
  }, [hasNetworkError, connected, refreshOffers]);

  // refresh on interval to detect newly assigned coupons
  // and limit redemptions refresh
  useInterval(refreshIfConnected, OFFERS_REFRESH_INTERVAL);
}
